// extracted by mini-css-extract-plugin
export var active = "_1k-9";
export var backButton = "_1k-8";
export var clone = "_1k-e";
export var collapseBar = "_1k-k";
export var collapseMode = "_1k-m";
export var collapsed = "_1k-o";
export var dimmed = "_1k-i";
export var dragHandle = "_1k-c";
export var dropdownIcon = "_1k-g";
export var expanding = "_1k-n";
export var hidden = "_1k-x";
export var iconContainer = "_1k-q";
export var iconSwapper = "_1k-w";
export var navItem = "_1k-6";
export var navItemIcon = "_1k-f";
export var navProfile = "_1k-7";
export var notificationCountBadge = "_1k-j";
export var notificationDot = "_1k-r";
export var optionsContainer = "_1k-h";
export var primaryNav = "_1k-0";
export var primaryNavDivider = "_1k-v";
export var primaryNavResizeHandle = "_1k-2";
export var primaryNavResizing = "_1k-1";
export var primaryNavTabSection = "_1k-u";
export var primaryTab = "_1k-p";
export var primaryTabIconBox = "_1k-s";
export var secondaryNav = "_1k-3";
export var selected = "_1k-t";
export var settingsNav = "_1k-4";
export var settingsNavItems = "_1k-5";
export var show = "_1k-d";
export var sideNav = "_1k-l";
export var teamItem = "_1k-a";
export var userProfileItem = "_1k-b";